export const getUniqueCompetitionsWithMatches = (matchesPlayed) => {
  const matches = Array.isArray(matchesPlayed) ? matchesPlayed : [];

  return matches
    .filter((item) => Number(item?.matches_count) > 0)
    .reduce((acc, current) => {
      const currentId = current?.competition__id ?? current?.competition_id;
      if (!acc.some((item) => {
        const itemId = item?.competition__id ?? item?.competition_id;
        return itemId !== undefined && itemId !== null && itemId === currentId;
      })) {
        acc.push(current);
      }
      return acc;
    }, []);
};
